import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import { useSelector } from "react-redux";
import { getMerchants } from '../../helpers/listsApi';
import { api } from '../../api';
import {useParams} from 'react-router-dom';
import { toast } from "react-toastify";


const ViewSupport = props => {
    const token = useSelector((state) => state.auth.token);

    const [merchants, setMerchants] = useState([]);
    const [adminData, setAdminData] = useState({});
    const { id: row_id } = useParams(); 
    useEffect(() => {
        getMerchants(false,token).then(dt => {
            setMerchants(dt)
        })
    }, [token])

    useEffect(() => {
        api.users
            .getUserByID({ usersId: row_id },token)
            .then((res) => {
                if (res.success === false) {
                    toast.error(res.message);
                }
                setAdminData(res.user)
            })
            .catch((err) => {
                toast.error("Something went wrong");
                console.log(err)
            }
            );
    }, [row_id,token])

    const status = [
        { value: true, label: "Active" },
        { value: false, label: "Inactive" }
    ]

    // const { viewModel, closeModal, adminData, adminId, handleGoToEit } = props;

    const getCurrrentMerchants = (merchants) => {
        const merchantValue = String(adminData.usersMerchentIds)
        const splidata = merchantValue.split(',');
        const currentMerchantsList = [];
        for (var i = 0; i < splidata.length; i++) {
            for (var j = 0; j < merchants.length; j++) {
                // eslint-disable-next-line
                if (splidata[i] == merchants[j].value) {
                    currentMerchantsList.push(merchants[j])
                }
            }
        }

        const result = [];
        currentMerchantsList.forEach(function (a) {
            result.push(a.label)
        });

        return result.join()

    }   

    return (

        <div className="container-fluid">
        <div className="row">
            <div className="col-sm-12">
                <div className="box-row">
                    <div className="table-head">
                        <h1 className="sec-header">VIEW SUPPORT</h1>
                    </div>
                    <div className="card">
                        <div className="card-body box-row">

                            {/* <h1 className="section-header float-left">Customer Details</h1> */}

                            <div style={{ position: 'absolute', top: '0px', right: '15px' }}>
                                <Link to={`/edit-support/${row_id}`}>
                                    <button className="btn mt-3 submit-btn" variant="primary" type="submit"> Edit </button>
                                </Link>
                            </div>

                            <div style={{ margin: '0px 50px' }}>
                                <div className="form-group row col-md-8">
                                    <div className="col-md-3"><span><b>User Name</b>{' '}:</span></div>
                                    <div className="col-md-5"><span>{adminData.usersUserName}</span></div>
                                </div>
                                
                            <div className="form-group row col-md-8">
                                <div className="col-md-3"><span><b>Email</b>{' '}:</span></div>
                                <div className="col-md-5"><span>{adminData.usersEmail}</span></div>
                            </div>

                            <div className="form-group row col-md-8">
                                    <div className="col-md-3"><span><b>Phone</b>{' '}:</span></div>
                                    <div className="col-md-5"><span>{adminData.usersPhone}</span></div>
                                </div>

                            <div className="form-group row col-md-8">
                                <div className="col-md-3"><span><b>Agent Name</b>{' '}:</span></div>
                                <div className="col-md-5"><span>{adminData.usersName}</span></div>
                            </div>

                            <div className="form-group row col-md-8">
                                <div className="col-md-3"><span><b>Merchants</b>{' '}:</span></div>
                                <div className="col-md-5"><span>{getCurrrentMerchants(merchants)}</span></div>
                            </div>

                            <div className="form-group row col-md-8">
                                <div className="col-md-3"><span><b>User Status</b>{' '}:</span></div>
                                <div className="col-md-5"><span>{Object.keys(status).length && adminData.usersStatus === true ? 'Active' : 'Inactive'}</span></div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div >
    )


}
export default ViewSupport;
